<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>Novo Aviso</h3>
      </div>

      <div slot="body" style="margin:0px;">
        <br>
        <div style="display: inline-block; width: 100%; margin-bottom: 30px !important">
          <label class="control-label" style="width: 15%;">Enviar para:</label>
          
          <select v-model="alertType" style="width: 20%; margin-left: 20px !important">
            <option value="0">Alunos</option>
            <option value="1" v-if="userType != 1">Administrativo</option>
            <option value="2" v-if="userType == 0">Professores</option>
          </select>

          <select v-if="alertType == '0'" @change="onChangeCourse($event)" 
          v-model="course" 
          id="course"
          style="width: 27%; margin-left: 20px !important">
            <option :value="null">Curso</option>
            <option
                v-for="course in courses"
                v-bind:key="course.id"
                v-bind:value="course.id"
              >{{course.name}}</option>
          </select>
          
          <select v-if="alertType == '0'" @change="onChangeModule($event)" 
          v-model="module" 
          id="module"
          style="width: 27%; margin-left: 20px !important">
            <option :value="null">Módulo</option>
            <option
                v-for="module in modules"
                v-bind:key="module.id"
                v-bind:value="module.id"
              >{{module.name}}</option>
          </select>
          <br />
        </div>
        
        <textarea v-model="alert.text" placeholder="Digite aqui a mensagem" style="width:100%" maxlength="3000" rows="9"></textarea>
      </div>

      <div slot="footer">
        <lms-button :disabled="saving" @click="save()" :loading="saving">Enviar</lms-button>
        <lms-button :disabled="false" @click="close()" :loading="false">Fechar</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      saving: false,
      alert: {},
      userType: this.$store.getters.user.type,
      alertType: 0,
      courses: [],
      course: null,
      modules: [],
      module: null
    };
  },
  methods: {
    save() {
      console.log("salvando o alerta");
      this.saving = true;
      const path = this.$global.endpoint + "/user/message/save";

      this.alert.Type = this.alertType;
      this.alert.courseId = this.course;
      this.alert.moduleId = this.module;
      console.log("ALERT", this.alert);

      axios
        .post(path, {
          alert: this.alert
        })
        .then(res => {
          this.saving = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Mensagem enviada com sucesso"
          });
          this.$emit("close");
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    close() {
      this.$emit("close");
    },
    onChangeCourse(event){

      this.course = event.target.value;

      if (this.course != null && this.course != ''){
        this.getModules();
        
      }else{
        this.course = null;
        
      }
      this.modules = null;
      this.module = null;
    },
    onChangeModule(event){

      this.module = event.target.value;

      if (this.module == null || this.module == ''){
        this.module = null;
      }
    },
    getCourses() {

      const path = this.$global.endpoint + "/course/getall";

      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
          console.log("returned getCourses")
        })
        .catch(error => {
          console.error(error);
        });
    },
    getModules() {
      
      const path = this.$global.endpoint + "/module/getall";

      axios
        .post(path, {
          courseId: this.course
        })
        .then(res => {
          this.modules = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.alert.Type = 0;
    this.getCourses();
  }
};
</script>
